<hang-map
  [location]="selectedLocation()"
  [enableSelection]="true"
  [enableAutocomplete]="true"
  (locationSelected)="handleLocationSelected($event)"
></hang-map>

<span class="on-surface-text title-small">
  {{ selectedLocation().displayName }}
</span>
<span class="on-surface-text body-small">{{ selectedLocation().address }}</span>
